import { useUserStore } from "@/src/stores/userStore";

export function logout() {
    localStorage.removeItem("user");
    useUserStore.getState().setUser(null);
    window.location.href = "/login";
}